import { PicklistOption } from "../blocks/fields/PicklistField.types";

/** /search's number operators, less Contains Data: a list's count always has one. */
export const NumberFilterOperators = [
  "equals",
  "doesnotequal",
  "isgreaterthan",
  "isgreaterthanorequalto",
  "islessthan",
  "islessthanorequalto",
] as const;

export type NumberFilterOperator = (typeof NumberFilterOperators)[number];

/** Held as "" for Equals, so an untouched filter leaves nothing in the query string. */
export const DefaultNumberFilterOperator: NumberFilterOperator = "equals";

export const NUMBER_FILTER_OPERATOR_OPTIONS: PicklistOption[] = [
  { Key: "equals", Value: "Equals" },
  { Key: "doesnotequal", Value: "Does Not Equal" },
  { Key: "isgreaterthan", Value: "Is Greater Than" },
  { Key: "isgreaterthanorequalto", Value: "Is Greater Than Or Equal To" },
  { Key: "islessthan", Value: "Is Less Than" },
  { Key: "islessthanorequalto", Value: "Is Less Than Or Equal To" },
];

/** The operator a stored value stands for; anything unrecognised reads as Equals. */
export function toNumberFilterOperator(stored: unknown): NumberFilterOperator {
  return NumberFilterOperators.find((operator) => operator === stored) ??
    DefaultNumberFilterOperator;
}

/** Whether a row's number passes the operator and the number it was asked against. */
export function numberMatches(
  cell: unknown,
  operator: NumberFilterOperator,
  wanted: number
) {
  const actual = Number(cell ?? 0);

  switch (operator) {
    case "doesnotequal":
      return actual !== wanted;
    case "isgreaterthan":
      return actual > wanted;
    case "isgreaterthanorequalto":
      return actual >= wanted;
    case "islessthan":
      return actual < wanted;
    case "islessthanorequalto":
      return actual <= wanted;
    default:
      return actual === wanted;
  }
}
